import React from 'react';
import { ShieldCheck, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-black" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="bg-zinc-900 rounded-3xl border border-green-500/30 overflow-hidden relative" data-id="element-85">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-green-400 via-green-500 to-green-600" data-id="element-86" />

          <div className="p-8 sm:p-12 text-center" data-id="element-87">
            <div className="inline-flex p-4 rounded-full bg-green-500/10 mb-6" data-id="element-88">
              <ShieldCheck className="w-12 h-12 text-green-500" data-id="element-89" />
            </div>

            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-90">
              Garantía de 7 Días
            </h2>
            <p className="text-zinc-400 mb-8 leading-relaxed" data-id="element-91">
              Si tienes cualquier inconveniente con el acceso o la descarga de
              los materiales, te devolvemos el 100% de tu dinero. Queremos que
              tu experiencia sea perfecta.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 text-sm font-medium text-zinc-300" data-id="element-92">
              <div className="flex items-center justify-center gap-2" data-id="element-93">
                <Check className="w-4 h-4 text-green-500" data-id="element-94" />
                Sin burocracia
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-95">
                <Check className="w-4 h-4 text-green-500" data-id="element-96" />
                Respuesta rápida
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-97">
                <Check className="w-4 h-4 text-green-500" data-id="element-98" />
                Acceso garantizado
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}